import { useState, useEffect } from 'react';
import Layout from '../../components/base/Layout';
import priceCategories from '../../../config/pricing.json'
import slides from '../../../config/slides.json'
import {SectionTitle, Subheading} from '../../components/modules/Titles';

export default function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const handleReservation = () => {
    window.open('https://re.asmobi.jp/9_hair_salon/', '_blank');
  };

  return (
    <Layout showNavigation={true}>
      {/* ヒーロースライダー */}
      <div className="relative h-[calc(100svh-4rem)] overflow-hidden">
        {/* 画像 */}
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={slide}
              alt={`hero-slide-{index}`}
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-black/30"></div>
          </div>
        ))}

        {/* 左右ボタン */}
        <button
          onClick={prevSlide}
          className="absolute left-8 top-1/2 transform -translate-y-1/2 w-12 h-12 flex items-center justify-center text-white hover:text-white/70 transition-colors cursor-pointer z-20"
        >
          <i className="ri-arrow-left-line text-2xl"></i>
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-8 top-1/2 transform -translate-y-1/2 w-12 h-12 flex items-center justify-center text-white hover:text-white/70 transition-colors cursor-pointer z-20"
        >
          <i className="ri-arrow-right-line text-2xl"></i>
        </button>

        {/* スライドインジケーター */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                index === currentSlide ? 'bg-white' : 'bg-white/50'
              }`}
            />
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* 価格表 */}
        <div id="price" className="mb-20">
          <SectionTitle>
            Price
          </SectionTitle>

          <div className="space-y-2 md:space-y-12">
            {priceCategories.map((category, categoryIndex) => (
              <div key={categoryIndex} className="border-b border-gray-200 pb-1 last:border-b-0">
                <Subheading>
                  {category.category}
                </Subheading>
                <div>
                  {category.services.map((service, serviceIndex) => (
                    <div key={serviceIndex} className="flex flex-row sm:items-center sm:justify-between sm:py-1 lg:py-4 border-b border-gray-100 last:border-b-0">
                      <div className="flex-1 mb-2 sm:mb-0">
                        <h4 className="font-medium text-black mb-1">
                          {service.name}
                        </h4>
                      </div>
                      <div className="font-medium text-black sm:ml-4">
                        {service.price}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* アクセス */}
        <div id="access" className="mb-20">
          <SectionTitle>
            Access
          </SectionTitle>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div className="space-y-8 md:space-y-12">
              <div>
                <Subheading>Address</Subheading>
                <p className="text-gray-700">
                  〒340-0034<br />
                  埼玉県草加市氷川町2140-12
                </p>
              </div>
              <div>
                <Subheading>Phone</Subheading>
                <p className="text-gray-700"><a href='tel:0489289009'>048-928-9009</a></p>
              </div>
              <div>
                <Subheading>Opening hours</Subheading>
                <p className="text-gray-700">
                  9：00～19：00<br />
                  パーマ 受付時間 9：00～17：00<br />
                  カット・カラー受付時間 9：00～18：00<br />
                  定休日: 毎週月曜日
                </p>
              </div>
              <div>
                <Subheading>Access</Subheading>
                <p className="text-gray-700 leading-relaxed">
                  草加駅西口より徒歩4分
                </p>
              </div>
            </div>
            <div>
              <div className="h-96 w-full rounded-lg overflow-hidden shadow-lg">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3234.8003278000847!2d139.799845!3d35.8293744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601891252201921d%3A0x103f7f523b993bc9!2zOe-8iOODiuOCpOODs--8iQ!5e0!3m2!1sja!2sjp!4v1757850237246!5m2!1sja!2sjp"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen={true}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="サロンの場所"
                ></iframe>
              </div>
            </div>
          </div>
        </div>

        {/* 予約ボタン */}
        <div className="mb-20 text-center">
          <div className="bg-gray-50 py-8 px-8 rounded-lg">
            <button
              onClick={handleReservation}
              className="px-12 py-4 bg-black text-white hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap text-lg rounded-md"
            >
              Reserve
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}
